var _defs, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTripasPremium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 120 120",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "shadow-premium",
    x: "-20%",
    y: "-20%",
    width: "140%",
    height: "140%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 2,
    dy: 6,
    stdDeviation: 4,
    floodColor: "#0F172A",
    floodOpacity: 0.25
  })), /*#__PURE__*/React.createElement("filter", {
    id: "glow-cyan",
    x: "-30%",
    y: "-30%",
    width: "160%",
    height: "160%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "blur"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lineGrad1",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0EA5E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#2563EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lineGrad2",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#EC4899"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#8B5CF6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "catGrad",
    x1: "0%",
    y1: "0%",
    x2: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#CBD5E1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(60, 62) scale(0.9)",
    opacity: 0.15,
    filter: "url(#shadow-premium)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-30,-15 L-38,-45 L-10,-28 Z",
    fill: "#475569"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30,-15 L38,-45 L10,-28 Z",
    fill: "#475569"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 32,
    fill: "#475569"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-25,5 L-45,2 M-25,10 L-48,10 M-25,15 L-44,18",
    stroke: "#475569",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25,5 L45,2 M25,10 L48,10 M25,15 L44,18",
    stroke: "#475569",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#shadow-premium)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 25,25 C 10,60 110,30 95,95",
    fill: "none",
    stroke: "url(#lineGrad1)",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 25,25 C 10,60 110,30 95,95",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeDasharray: "5 4",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 95,25 C 70,55 30,65 25,95",
    fill: "none",
    stroke: "url(#lineGrad2)",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 95,25 C 70,55 30,65 25,95",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeDasharray: "5 4",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 11,
    fill: "#FFFFFF",
    stroke: "#0EA5E9",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 6,
    fill: "#0EA5E9",
    filter: "url(#glow-cyan)"
  }), /*#__PURE__*/React.createElement("text", {
    x: 25,
    y: 29,
    fontFamily: "system-ui, sans-serif",
    fontSize: 11,
    fontWeight: 900,
    fill: "#FFFFFF",
    textAnchor: "middle"
  }, "1"), /*#__PURE__*/React.createElement("circle", {
    cx: 95,
    cy: 25,
    r: 11,
    fill: "#FFFFFF",
    stroke: "#EC4899",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 95,
    cy: 25,
    r: 6,
    fill: "#EC4899"
  }), /*#__PURE__*/React.createElement("text", {
    x: 95,
    y: 29,
    fontFamily: "system-ui, sans-serif",
    fontSize: 11,
    fontWeight: 900,
    fill: "#FFFFFF",
    textAnchor: "middle"
  }, "2"), /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 95,
    r: 11,
    fill: "#FFFFFF",
    stroke: "#8B5CF6",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 95,
    r: 6,
    fill: "#8B5CF6"
  }), /*#__PURE__*/React.createElement("text", {
    x: 25,
    y: 99,
    fontFamily: "system-ui, sans-serif",
    fontSize: 11,
    fontWeight: 900,
    fill: "#FFFFFF",
    textAnchor: "middle"
  }, "2"), /*#__PURE__*/React.createElement("circle", {
    cx: 95,
    cy: 95,
    r: 11,
    fill: "#FFFFFF",
    stroke: "#2563EB",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 95,
    cy: 95,
    r: 6,
    fill: "#2563EB",
    filter: "url(#glow-cyan)"
  }), /*#__PURE__*/React.createElement("text", {
    x: 95,
    y: 99,
    fontFamily: "system-ui, sans-serif",
    fontSize: 11,
    fontWeight: 900,
    fill: "#FFFFFF",
    textAnchor: "middle"
  }, "1"))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(60, 52) rotate(-15)",
    filter: "url(#shadow-premium)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-8,-8 L-4,-4 M8,-8 L4,-4 M0,-10 L0,-6",
    stroke: "#FFD54F",
    strokeWidth: 2,
    strokeLinecap: "round",
    opacity: 0.9
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTripasPremium);
export default __webpack_public_path__ + "static/media/tripas_premium.720cf10c1ababf895237a9cd8ffe3b37.svg";
export { ForwardRef as ReactComponent };